import { render, staticRenderFns } from "./oxySnap.vue?vue&type=template&id=572717d6&scoped=true&"
import script from "./oxySnap.vue?vue&type=script&lang=js&"
export * from "./oxySnap.vue?vue&type=script&lang=js&"
import style0 from "./oxySnap.vue?vue&type=style&index=0&id=572717d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572717d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('572717d6')) {
      api.createRecord('572717d6', component.options)
    } else {
      api.reload('572717d6', component.options)
    }
    module.hot.accept("./oxySnap.vue?vue&type=template&id=572717d6&scoped=true&", function () {
      api.rerender('572717d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/introduce/oxySnap.vue"
export default component.exports